"use strict";
import { AxisLeft } from "components/Charts/ActiveLiquidityChart/AxisLeft";
import { Brush2 } from "components/Charts/ActiveLiquidityChart/Brush2";
import { HorizontalArea } from "components/Charts/ActiveLiquidityChart/HorizontalArea";
import { HorizontalLine } from "components/Charts/ActiveLiquidityChart/HorizontalLine";
import { max as getMax, scaleLinear } from "d3";
import { useEffect, useMemo } from "react";
import { useSporeColors } from "ui/src";
const xAccessor = (d) => d.activeLiquidity;
const yAccessor = (d) => d.price0;
export function ActiveLiquidityChart2({
  id = "ActiveLiquidityChart2",
  data: { series, current, min, max },
  dimensions: { width, height, contentWidth, axisLabelPaneWidth },
  brushDomain,
  onBrushDomainChange,
  disableBrushInteraction
}) {
  const colors = useSporeColors();
  const { xScale, yScale } = useMemo(() => {
    const activeEntries = min && max ? series.filter((d) => d.price0 >= min && d.price0 <= max) : series;
    const scales = {
      yScale: scaleLinear().domain([min, max]).range([0, height]),
      xScale: scaleLinear().domain([0, getMax(activeEntries, xAccessor)]).range([axisLabelPaneWidth, axisLabelPaneWidth + contentWidth])
    };
    return scales;
  }, [min, max, series, height, axisLabelPaneWidth, contentWidth]);
  useEffect(() => {
    if (!brushDomain) {
      const [min2, max2] = yScale.domain();
      const lowerBound = min2 + (max2 - min2) * 0.2;
      const upperBound = min2 + (max2 - min2) * 0.8;
      onBrushDomainChange([lowerBound, upperBound], void 0);
    }
  }, [brushDomain, onBrushDomainChange, yScale]);
  return <><svg
    width="100%"
    height="100%"
    viewBox={`0 0 ${width} ${height}`}
    style={{ overflow: "visible", transform: "scale(-1, -1)" }}
  >
    <defs>
      <clipPath id={`${id}-chart-clip`}><rect x="0" y="0" width={width} height={height} /></clipPath>
      {brushDomain && // mask to highlight selected area
      <mask id={`${id}-chart-area-mask`}><rect
        fill="white"
        y={yScale(brushDomain[0])}
        x={axisLabelPaneWidth - 1}
        height={yScale(brushDomain[1]) - yScale(brushDomain[0])}
        width={contentWidth + 2}
      /></mask>}
    </defs>
    <g>
      <g clipPath={`url(#${id}-chart-clip)`}>
        <HorizontalArea
          series={series}
          xScale={xScale}
          yScale={yScale}
          xValue={xAccessor}
          yValue={yAccessor}
          brushDomain={brushDomain}
          fill={colors.neutral1.val}
          selectedFill={colors.accent1.val}
          containerHeight={height}
        />
        <HorizontalLine value={current} yScale={yScale} xScale={xScale} width={contentWidth + 12} />
        <AxisLeft
          yScale={yScale}
          offset={12}
          min={brushDomain?.[0]}
          current={current}
          max={brushDomain?.[1]}
          height={height}
        />
      </g>
      <Brush2
        id={id}
        yScale={yScale}
        interactive={!disableBrushInteraction}
        brushExtent={brushDomain ?? yScale.domain()}
        width={width}
        height={height}
        offset={axisLabelPaneWidth}
        setBrushExtent={onBrushDomainChange}
      />
    </g>
  </svg></>;
}
